import classNames from 'classnames';
import styles from './styles.module.scss';

const createShimmer = (baseClassName: string) =>
  function ({ className = '' }: { className?: string }) {
    return <div className={classNames(baseClassName, className)} />;
  };

const ProfilePhotoShimmer = createShimmer(styles.profilePhoto);
const TextShimmer = createShimmer(styles.text);
const TrailPhotoShimmer = createShimmer(styles.trailPhoto);
const SubtextShimmer = createShimmer(styles.subtext);

const ShimmerComponents = {
  ProfilePhotoShimmer,
  TextShimmer,
  TrailPhotoShimmer,
  SubtextShimmer
};

export default ShimmerComponents;
